import { render } from "./company-intellectual-property.vue?vue&type=template&id=3881332b&scoped=true"
import script from "./company-intellectual-property.vue?vue&type=script&lang=js"
export * from "./company-intellectual-property.vue?vue&type=script&lang=js"

import "./company-intellectual-property.vue?vue&type=style&index=0&id=3881332b&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3881332b"]])

export default __exports__